import React from 'react';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { isNil } from 'lodash';

const PropertiesInfoRoot = styled.div<{ size?: 'medium' | 'large'; }>`
  ${({ theme, size = 'medium' }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.neutrals.grey10};
    border-radius: ${theme.borderRadius.medium};
    margin-top: ${theme.spacing(size === 'medium' ? 3 : 2)};
    width: 100%;
    height: ${size === 'medium' ? 58 : 66}px;
    padding: ${theme.spacing(1.5)} ${theme.spacing(1)};
  `}
`;

const PropertiesInfoValue = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

const PropertiesInfoText = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
    margin-top: ${theme.spacing(0.25)};
  `}
`;

const PropertiesInfoItem = styled(Text)`
  flex-grow: 1;
  text-align: center;
`;

const Separator = styled.div`
  ${({ theme }) => `
    width: 1px;
    height: 100%;
    background-color: ${theme.colors.neutrals.grey6};
    margin: 0 ${theme.spacing(1)};
  `}
`;


interface PropertiesInfoProps {
  soldCount: number;
  exclusiveListingsCount: number;
  size?: 'medium' | 'large';
}

const EMPTY = '-';

export const PropertiesInfo: React.FC<PropertiesInfoProps> = props => {
  const {
    soldCount = null,
    exclusiveListingsCount = null,
    size = 'medium',
  } = props;
  const { t } = useLocale();

  if (isNil(soldCount) && isNil(exclusiveListingsCount)) return null;

  return (
    <PropertiesInfoRoot size={size}>
      <PropertiesInfoItem>
        <PropertiesInfoValue weight="bold">
          {isNil(soldCount) ? EMPTY : soldCount}
        </PropertiesInfoValue>
        <PropertiesInfoText>{t('madad.soldCountLabel')}</PropertiesInfoText>
      </PropertiesInfoItem>
      <Separator />
      <PropertiesInfoItem>
        <PropertiesInfoValue weight="bold">
          {isNil(exclusiveListingsCount) ? EMPTY : exclusiveListingsCount}
        </PropertiesInfoValue>
        <PropertiesInfoText>{t('madad.exclusiveListingsLabel')}</PropertiesInfoText>
      </PropertiesInfoItem>
    </PropertiesInfoRoot>
  );
};
